import { type ProjectRole, Role } from '@droidmap/permissions-service-contract'

/**
 * The project roles a user or group can be granted, with their display
 * labels, in descending order of access. Shared by the project permissions
 * page and the create-project dialog's Access section (#3077).
 */
export const PROJECT_ROLE_OPTIONS: ReadonlyArray<{
  value: ProjectRole
  label: string
}> = [
  { value: Role.PROJECT_ADMIN, label: 'Project Admin' },
  { value: Role.PROJECT_WRITE, label: 'Project Write' },
  { value: Role.PROJECT_READ, label: 'Project Read' },
]

/**
 * Whether a project grant belongs in the editable "Project access" table.
 * `ORG_ADMIN` grants on a project are copies of the org's admin grants
 * (#3085): they are shown read-only, from the org, and can't be removed here.
 */
export const isProjectAccessGrant = (grant: { role: Role }): boolean =>
  grant.role !== Role.ORG_ADMIN
